import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./contexts/AuthContext";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/dashboard/Account";
import Callbacks from "./pages/dashboard/Callbacks";
import Deposits from "./pages/dashboard/Deposits";
import Devices from "./pages/dashboard/Devices";
import Developers from "./pages/dashboard/Developers";
import Overview from "./pages/dashboard/Overview";
import PaymentLinks from "./pages/dashboard/PaymentLinks";
import PayinGateway from "./pages/dashboard/PayinGateway";
import Payouts from "./pages/dashboard/Payouts";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PayPage from "./pages/PayPage";

function App() {
  useEffect(() => {
    document.title = "SuperCash — Money lands in YOUR account.";
  }, []);

  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#fff",
            color: "#14101F",
            border: "2.5px solid #14101F",
            borderRadius: 14,
            boxShadow: "4px 4px 0 #14101F",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
          },
        }}
      />
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pay_id/:code" element={<PayPage />} />
            {/* Back-compat for legacy short links */}
            <Route path="/p/:code" element={<PayPage />} />

            <Route
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            >
              <Route path="/overview" element={<Overview />} />
              <Route path="/links" element={<PaymentLinks />} />
              <Route path="/deposits" element={<Deposits />} />
              <Route path="/devices" element={<Devices />} />
              <Route path="/account" element={<Account />} />
              <Route path="/developers" element={<Developers />} />
              <Route path="/callbacks" element={<Callbacks />} />
              <Route path="/payin-gateway" element={<PayinGateway />} />
              <Route path="/payout" element={<Payouts />} />
            </Route>

            {/* Back-compat redirects from the legacy /dashboard/* paths */}
            <Route path="/dashboard" element={<Navigate to="/overview" replace />} />
            <Route path="/dashboard/links" element={<Navigate to="/links" replace />} />
            <Route path="/dashboard/deposits" element={<Navigate to="/deposits" replace />} />
            <Route path="/dashboard/devices" element={<Navigate to="/devices" replace />} />
            <Route path="/dashboard/account" element={<Navigate to="/account" replace />} />
            <Route path="/dashboard/developers" element={<Navigate to="/developers" replace />} />
            <Route path="/dashboard/callbacks" element={<Navigate to="/callbacks" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
